import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class ArchiveQDN {
  constructor() {
    const tablet = window.matchMedia("(max-width: 1040px)");
    let cache = {};
    let filter = {};
    let type;
    let nbCards = document.querySelector('.archive_posts').dataset.posts;
    let nbLoad = 0;
    let heightBlock = 0;
    let tab1 = true;
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.page = document.querySelector('.template-archive');
      cache.postContainer = document.querySelector('.post-container');
      cache.cards = cache.postContainer.querySelectorAll('.post_card');

      cache.filters = document.querySelectorAll('.filter_tag');
      cache.filterDropBtn = document.querySelector('.drop_filter');
      cache.filterDrop = document.querySelector('.filter_inner');

      if(document.querySelector('.load-more')) {
        cache.loadMore = document.querySelector('.load-more');
        let height = cache.cards[0].offsetHeight;
        if(tablet.matches) {
          nbCards = 4;
          heightBlock = nbCards * height + 20*nbCards;
        } else {
          heightBlock = nbCards/3 * height + 20*nbCards/3;
        }
        cache.postContainer.style.height = heightBlock+'px';
        nbLoad = cache.cards.length/nbCards;
      }
    };

    let registerEvents = () => {
      for (var i = 0; i < cache.filters.length; i++) {
        cache.filters[i].addEventListener("click", filterPost);
      }
      cache.filterDropBtn.addEventListener("click", openFilter);
      if(document.querySelector('.load-more')) {
        cache.loadMore.addEventListener("click", loadMore);
      }
    };


    let filterPost = function() {
      document.querySelector('.filter_tag.active').classList.remove('active');
      this.classList.add('active');
      let t = this;
      let filter = t.dataset.filter;
      let cards = cache.cards;


      for (let i = 0; i < cache.cards.length; i++) {
        anime({
          targets: cache.cards[i],
          opacity: 0,
          duration: 200,
          delay:(50*i),
          easing: 'easeInOutCubic',
          complete: function() {
            if(i == cache.cards.length-1) {
              if(t.classList.contains('filter_all')) {
                for (let ii = 0; ii < cards.length; ii++) {
                  if(cards[ii].classList.contains('hide_card')) {
                    cards[ii].classList.remove('hide_card');
                  }
                }
              } else {
                for (let ii = 0; ii < cards.length; ii++) {
                    if(cards[ii].classList.contains(filter) && cards[ii].classList.contains('hide_card')) {
                      cards[ii].classList.remove('hide_card');
                    } else if(!cards[ii].classList.contains(filter) && !cards[ii].classList.contains('hide_card')) {
                      cards[ii].classList.add('hide_card');
                    }
                }

              }
              setTimeout(() => {
                for (let i = 0; i < cache.cards.length; i++) {
                  anime({
                    targets: cache.cards[i],
                    opacity: 1,
                    duration: 200,
                    delay:(50*i),
                    easing: 'easeInOutCubic',
                  });
                }
              }, 100)
            }
          }
          })
        }

      if(tablet.matches) {
        openFilter();
        cache.filterDropBtn.querySelector('.txt').innerHTML = this.innerHTML;
      }
    }


    let openFilter = function() {
      if(cache.filterDropBtn.classList.contains('open')) {
        anime({
          targets: cache.filterDropBtn.querySelector('svg'),
          rotate: 0,
          duration: 400,
          easing: 'easeInOutCubic',
        });
        anime({
          targets: cache.filterDrop,
          height: 0,
          duration: 400,
          easing: 'easeInOutCubic',
          complete: function() {
            cache.filterDrop.style.display = "none";
            cache.filterDropBtn.classList.remove('open');
          }
        });
      } else {
        cache.filterDrop.style.display = "block";
        cache.filterDrop.style.height = "auto";
        let height = cache.filterDrop.offsetHeight;
        cache.filterDrop.style.height = 0;
        anime({
          targets: cache.filterDropBtn.querySelector('svg'),
          rotate: -180,
          duration: 400,
          easing: 'easeInOutCubic',
        });
        anime({
          targets: cache.filterDrop,
          height: [0,height],
          duration: 400,
          easing: 'easeInOutCubic',
          complete: function() {
            cache.filterDropBtn.classList.add('open');
          }
        });
      }
    }

    let loadMore = function() {
      nbLoad = nbLoad - 1;
      if(nbLoad < 1) {
        cache.loadMore.classList.add('disabled');
        let height = 0;
        let heightCard = cache.cards[0].offsetHeight;
        let totalCards = cache.cards.length;
        let diffCards = totalCards - (Math.floor(cache.cards.length/nbCards) * nbCards);
        if(tablet.matches) {
          height = diffCards * heightCard  + 40;
        } else {
          height = Math.ceil(diffCards/3) * heightCard  + 60;
        }
        anime({
          targets: cache.postContainer,
          height: cache.postContainer.offsetHeight + height,
          duration: 300,
          easing: 'easeInOutCubic',
        });
      }
      else {
        anime({
          targets: cache.postContainer,
          height: cache.postContainer.offsetHeight + heightBlock,
          duration: 300,
          easing: 'easeInOutCubic',
        });
      }
    }



    initFunc();
  };
}
export { ArchiveQDN }
